import { render, staticRenderFns } from "./GrandPrize.vue?vue&type=template&id=bcf47e3e&scoped=true&"
import script from "./GrandPrize.vue?vue&type=script&lang=js&"
export * from "./GrandPrize.vue?vue&type=script&lang=js&"
import style0 from "./GrandPrize.vue?vue&type=style&index=0&id=bcf47e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf47e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcf47e3e')) {
      api.createRecord('bcf47e3e', component.options)
    } else {
      api.reload('bcf47e3e', component.options)
    }
    module.hot.accept("./GrandPrize.vue?vue&type=template&id=bcf47e3e&scoped=true&", function () {
      api.rerender('bcf47e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/components/GrandPrize.vue"
export default component.exports